import classNames from 'classnames';

import Button from '@/components/shared/Button/Button';

type CreateCollectionFormHeaderProps = {
  isEdit: boolean;
  isSubmitting: boolean;
  onBack: () => void;
  onSubmit: () => void;
};

const CreateCollectionFormHeader = ({
  isEdit,
  isSubmitting,
  onBack,
  onSubmit,
}: CreateCollectionFormHeaderProps) => {
  return (
    <div className="flex items-center justify-between">
      <Button
        variant="transparent"
        className="border-none mr-4 w-fit text-xl !p-0"
        prefixIcon={<img src="/icons/arrow-left.svg" alt="arrow-left" className="mr-4" />}
        onClick={onBack}
        label={isEdit ? 'Edit Collection' : 'Create Collection'}
      />
      <Button
        type="submit"
        onClick={onSubmit}
        label={isSubmitting ? 'Saving...' : 'Save'}
        disabled={isSubmitting}
        className={classNames('opacity-100 cursor-pointer w-fit', {
          'opacity-50 cursor-not-allowed': isSubmitting,
        })}
        prefixIcon={<img src="/icons/save.svg" alt="save" />}
      />
    </div>
  );
};

export default CreateCollectionFormHeader;
